/**
 * Chart theme — one palette for every visualisation in the product.
 *
 * The categorical slots are assigned in FIXED order (sms → voiceSms → aiVoice →
 * whatsapp) and are never cycled or re-shuffled when a series drops out, so a
 * channel keeps its colour no matter which filter is applied.
 *
 * Validated on a #ffffff surface (lightness band, chroma floor, protan/deutan
 * separation, normal-vision separation, 3:1 contrast) — all checks pass, worst
 * adjacent pair ΔE 13.1 under protanopia. Do not hand-tweak these hex values
 * without re-validating; nudging one step can silently collapse a pair for
 * colour-blind readers.
 */

/* ── Categorical: channel identity ──────────────────────────────────────── */
export const CHANNEL_COLORS = {
  sms: '#009e97', // slot 1 — brand teal
  voiceSms: '#eb6834', // slot 2 — orange
  aiVoice: '#2a78d6', // slot 3 — blue
  whatsapp: '#c98500', // slot 4 — amber
};

export const CATEGORICAL = [
  CHANNEL_COLORS.sms,
  CHANNEL_COLORS.voiceSms,
  CHANNEL_COLORS.aiVoice,
  CHANNEL_COLORS.whatsapp,
];

/* ── Status: reserved meaning, always shipped with an icon + label ──────── */
export const STATUS_COLORS = {
  good: '#0ca30c',
  warning: '#fab219',
  serious: '#ec835a',
  critical: '#d03b3b',
};

/* ── Neutrals ───────────────────────────────────────────────────────────── */
export const SURFACE = '#ffffff';
/** Context/reference marks (e.g. "delivered" behind "engaged") — not an identity. */
export const NEUTRAL_MARK = '#e2e5e9';
export const GRID_STROKE = '#f1f3f5';
export const AXIS_TICK = '#8a9099';

/** Shared recharts axis props — recessive, no axis lines, no tick marks. */
export const axisProps = {
  tickLine: false,
  axisLine: false,
  tick: { fill: AXIS_TICK, fontSize: 12 },
  dy: 8,
};

export const yAxisProps = {
  tickLine: false,
  axisLine: false,
  tick: { fill: AXIS_TICK, fontSize: 12 },
  width: 40,
  dx: -4,
};

export const gridProps = {
  stroke: GRID_STROKE,
  vertical: false,
  strokeDasharray: '0',
};
